const HORIZONTAL = 'horizontal'
const VERTICAL = 'vertical'

const initialState = () => ({
  orientationProfiler: HORIZONTAL
})

const actions = {
  toggleProfilerOrientation ({ commit }) {
    commit('TOGGLE_PROFILER_ORIENTATION')
  }
}

const mutations = {
  TOGGLE_PROFILER_ORIENTATION (state) {
    state.orientationProfiler = state.orientationProfiler === HORIZONTAL ? VERTICAL : HORIZONTAL
  }
}

export default {
  state: initialState(),
  mutations,
  actions
}
